module.exports = __webpack_public_path__ + "img/aniversary.a3428f5c.png";